<template>
  <!-- This component is renderless, it only handles script injection -->
  <!-- Vue requires a root element. We use a hidden div to satisfy this requirement. -->
  <div style="display: none;"></div>
</template>

<script>
import { getLocalesPath } from '@/i18nPath.js';

export default {
  name: 'OneTrustLoader',
  props: {
    currentLanguage: {
      type: String,
      required: true,
      validator: (value) => ['en', 'fr'].includes(value)
    }
  },
  setup(props) {
    const injectOneTrustScripts = async () => {
      // 1. Fetch the config from the public folder based on language
      let scriptId = '';
      
      try {
        // We use fetch() because the files are in the 'public' folder (static assets)
        const response = await fetch(`${getLocalesPath()}${props.currentLanguage}.json`);
        
        if (!response.ok) {
            throw new Error(`Failed to load locale file: ${response.statusText}`);
        }

        const config = await response.json();
        
        // Assuming your JSON key is 'oneTrustId'. Adjust this key if your JSON is different.
        // Example JSON content: { "oneTrustId": "019493f1-ae8f-7b6b-9c48-7bd94aad7116-test" }
        scriptId = config.oneTrustId;

      } catch (error) {
        console.error('OneTrustLoader Error:', error);
        return; // Exit if we can't get the ID
      }

      if (!scriptId) {
        console.error('OneTrust ID not found in fetched JSON.');
        return;
      }

      // 2. Check if script is already present to prevent duplicates
      if (document.getElementById('ot-sdk-stub')) return;

      // 3. Create and append the OtAutoBlock script
      const autoBlockScript = document.createElement('script');
      autoBlockScript.src = `https://cdn.cookielaw.org/consent/${scriptId}/OtAutoBlock.js`;
      autoBlockScript.type = 'text/javascript';
      document.head.appendChild(autoBlockScript);

      // 4. Create and append the SDK Stub script
      const sdkStubScript = document.createElement('script');
      sdkStubScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      sdkStubScript.type = 'text/javascript';
      sdkStubScript.charset = 'UTF-8';
      sdkStubScript.setAttribute('data-domain-script', scriptId);
      sdkStubScript.id = 'ot-sdk-stub'; // Adding ID for duplicate check
      
      document.head.appendChild(sdkStubScript);

      // 5. Define the OptanonWrapper global function
      window.OptanonWrapper = function() { };
    };

    // Inject immediately upon component setup
    injectOneTrustScripts();

    return {};
  }
};
</script>